import { useQuery } from 'react-query';
import { axios, axios2, AXIOS } from '@/lib/axiosData';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Listing } from '@/types';

export const landingPage = ({
  type,
  filter_data,
  search_data,
  country,
  sub_category,
  latitude,
  longitude,
  subscription_tyre,
  min_price,
  max_price,
  page,
}: {
  filter_data: boolean;
  country: string;
  type: any;
  search_data: string;
  sub_category: string;
  latitude: string;
  longitude: string;
  subscription_tyre: string;
  min_price: string;
  max_price: string;
  page: number;
}): Promise<Listing[]> => {
  console.log(country, 'country--in api');
  return AXIOS.get(`/customer-api/home-page-data-unauthorzie`, {
    params: {
      filter_data,
      type,
      search_data,
      sub_category,
      country,
      latitude,
      longitude,
      subscription_tyre,
      min_price,
      max_price,
      page,
      page_size: 8,
    },
  });
};

type QueryFnType = typeof landingPage;

type UseNewListingOptions = {
  config?: QueryConfig<QueryFnType>;
  type: any;
  filter_data: boolean;
  search_data: string;
  sub_category: string;
  latitude: string;
  longitude: string;
  subscription_tyre: string;
  min_price: string;
  max_price: string;
  page: number;
  country: string;
};

export const useLandingPage = ({
  config,
  country,
  type,
  filter_data,
  search_data,
  sub_category,
  latitude,
  longitude,
  subscription_tyre,
  min_price,
  max_price,
  page,
}: UseNewListingOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      'listing-landing-page',
      {
        type,
        filter_data,
        search_data,
        sub_category,
        latitude,
        longitude,
        country,
        subscription_tyre,
        page,
      },
    ],
    queryFn: () =>
      landingPage({
        filter_data,
        type,
        search_data,
        country,
        sub_category,
        latitude,
        longitude,
        subscription_tyre,
        min_price,
        max_price,
        page,
      }),
  });
};

export const countryList = () => {
  return axios2.get(`/customer-api/fetch-all-countries`);
};

export const useCountryList = () => {
  return useQuery({
    queryKey: ['country-list'],
    queryFn: countryList,
  });
};

export const topCountryList = () => {
  return axios2.get(`/customer-api/get-top-countries`);
};

export const useTopCountryList = () => {
  return useQuery({
    queryKey: ['top-country-list'],
    queryFn: topCountryList,
  });
};
